module.exports = __webpack_public_path__ + "img/pasture_natural_middle.ded0fa8f.jpg";